import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Car02 = function Car02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 10V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 3 16.9201 3 15.8 3H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 4.5198 5 5.08 5 6.2V10m0-1H2V8m17 1h3V8M6 13.5h.01m11.99 0h.01M6.8 10h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.2798 22 13.1198 22 14.8V18c0 .9319 0 1.3978-.1522 1.7654-.203.49-.5924.8794-1.0824 1.0824C20.3978 21 19.9319 21 19 21h-.6c-.3716 0-.5574 0-.7129-.0246a2 2 0 0 1-1.6625-1.6625C16 19.1574 16 18.9716 16 18.6c0-.0929 0-.1394-.0062-.1782a.5.5 0 0 0-.4156-.4156C15.5394 18 15.4929 18 15.4 18H8.6c-.0929 0-.1394 0-.1782.0062a.5.5 0 0 0-.4156.4156C8 18.4606 8 18.5071 8 18.6c0 .3716 0 .5574-.0246.7129a2 2 0 0 1-1.6625 1.6625C6.1574 21 5.9716 21 5.6 21H5c-.9319 0-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C2 19.3978 2 18.9319 2 18v-3.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 10 5.1198 10 6.8 10m-.3 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m12 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 18.5 13.5"
    })
  }));
};
export default Car02;